import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsFindYourIssueRoute: InvariantJiraRoute = {
	name: 'plan-settings-find-your-issue',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue',
};
